import type { AttributesMap, SetQueriesProps } from '@/utils/product/types';

export const setProductQueries = (props: SetQueriesProps) => {
    const { searchParams } = props;
    const newSearchParams = new URLSearchParams(searchParams.toString());
    if (props.type === 'variant') {
        if (props.clear) {
            newSearchParams.delete('variant');
            return newSearchParams.toString();
        }
        const currentAttribute = props.attributes.get(props.key);
        if (currentAttribute) {
            const fetchedVariant = props.variants.find((currV) =>
                Object.entries(
                    JSON.parse(
                        currV.VariantDefiningAttributes,
                    ) as AttributesMap,
                ).every(
                    ([k, v]) => currentAttribute.attrs[k].Value === v.Value,
                ),
            );
            newSearchParams.set('variant', fetchedVariant?.id || '');
            return newSearchParams.toString();
        }
    }
    if (props.type === 'lightsource') {
        newSearchParams.set('lightsource', props.lightsourceId);
        return newSearchParams.toString();
    }
    return newSearchParams.toString();
};
